import { React, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Pagination, Navigation } from "swiper";
import "swiper/css";
import {
  SVGIcons,
  ImgIcons,
  Imgbanner,
  getcolors
} from "../../Helpers/Common";
import { Link } from "react-router-dom";
import { Showdetailspopup } from "../Showdetailspopup/Showdetailspopup";
import Hover from "../OnHoverDetails/Hover"


var SVGIcon = "";
SVGIcons().then((resultData) => (SVGIcon = resultData));

export function Layout17(props) {
  const [showdetails, setshowdetails] = useState(false);
  const [details, setdetails] = useState(false);

  function showdetailspop(data) {
    setshowdetails(true);
    setdetails(data)
  }
  let Closepopup = () => { setshowdetails(false); }
  return (
    <>
      <section className="mb-0">
        <>
          <section className="mb-0 dD-none">
            <div className="temp72">

              <div className="temp72-area">

                <Swiper slidesPerView={2.4}
                  spaceBetween={16}
                  freeMode={true}
                  loop={false}
                  loopFillGroupWithBlank={true}
                  centeredSlides={false}
                  modules={[FreeMode, Pagination]}
                  breakpoints={{
                    700: {
                      slidesPerView: 4.2,
                    },
                    850: {
                      slidesPerView: 6.3,
                    },
                  }}
                  className="temp72-slider">
                  <SwiperSlide className="temp72-item">

                    <h4>{props.title.display_title} <span className="red">{props.title.display_title_sufix}</span></h4>
                    <p>{props.title.section_log_line}</p>

                  </SwiperSlide>

                  {

                    props.Layout1.map((data, index) => {

                      var bgcolors = getcolors;
                      var random = Math.floor(Math.random() * bgcolors.length);
                      if (data.content_bg_color != "#000000") {
                        var bgcolor = { 'backgroundColor': data.content_bg_color };
                      } else {
                        var bgcolor = { 'backgroundColor': bgcolors[random] };
                      }
                      var premium = "";
                      if (data.premium && !data.original_tag) {
                        var premium = (
                          <img
                            src="https://dbcms.docubay.com/media-upload/1691135448-golden-d-new.png"
                            style={{ width: "1rem", "margin-bottom": "5px","margin-rigth":"10px" ,"border-radius":"0px"}}
                          />
                        );
                      }
                      if (data.original_tag && data.premium) {
                        var original = <img src={SVGIcon["Premvg.svg"]} />;
                      }
                      var GenereTitle = data.genres.split(",");
                      GenereTitle = GenereTitle[0];
                      return (
                        <SwiperSlide key={index} className="temp72-item"  >

                          <div onClick={() => { showdetailspop(data) }} >

                            <div className="temp72-itemColor" style={bgcolor}>
                              <img src={data.thumbnail_image2.medium} />
                            </div>
                            <div className="bay-title">{GenereTitle}</div>
                            <div className="premium-red">
                              {premium}
                              {original}
                            </div>

                          </div>

                        </SwiperSlide>
                      )
                    })
                  }
                  <SwiperSlide></SwiperSlide>
                </Swiper>
              </div>
            </div>
          </section>

          <section>
            <div className="temp72 mb-0 dD-block">
              <div className="temp72-area">
                <Swiper
                  navigation={{
                    prevEl: ".slick-prev",
                    nextEl: ".slick-next",
                  }}
                  slidesPerView={2.4}
                  spaceBetween={16}
                  freeMode={true}
                  loop={false}
                  loopFillGroupWithBlank={true}
                  centeredSlides={false}
                  breakpoints={{
                    650: {
                      slidesPerView: 1,
                    },
                    850: {
                      slidesPerView: 6.3,
                    },
                  }}
                  modules={[FreeMode, Pagination, Navigation]}
                  className="temp72-slider">
                  <button className="slick-prev slick-arrow" type="button" aria-label="Previous" />
                  {
                    props.Layout1.map((data, index) => {
                      var bgcolors = getcolors;
                      var random = Math.floor(Math.random() * bgcolors.length);
                      if (data.content_bg_color != "#000000") {
                        var bgcolor = { 'backgroundColor': data.content_bg_color };
                      } else {
                        var bgcolor = { 'backgroundColor': bgcolors[random] };
                      }
                      var premium = "";
                      if (data.premium && !data.original_tag) {
                        var premium = (
                          <img
                            src="https://dbcms.docubay.com/media-upload/1691135448-golden-d-new.png"
                            style={{ width: "1rem", "margin-bottom": "5px","margin-rigth":"10px" ,"border-radius":"0px"}}
                          />
                        );
                      }
                      if (data.original_tag && data.premium) {
                        var original = <img src={SVGIcon["Premvg.svg"]} />;
                      }
                      var GenereTitle = data.genres.split(",");
                      GenereTitle = GenereTitle[0];
                      if (index == 0) {
                        return (
                          <SwiperSlide className="temp72-item">
                            <h4>{props.title.display_title} <span className="red">{props.title.display_title_sufix}</span></h4>
                            <p>{props.title.section_log_line}</p>
                          </SwiperSlide>
                        )
                      } else {
                        return (
                          <SwiperSlide key={index} className="temp72-item" >
                            <Hover data={data} />
                            <div className="temp72-itemColor" style={bgcolor}>
                              <img src={data.thumbnail_image2.medium} />
                            </div>
                            <div className="bay-title">{GenereTitle}</div>
                            <div className="premium-red">
                              {premium}
                              {original}
                            </div>
                          </SwiperSlide>
                        )
                      }
                    })
                  }
                  <SwiperSlide></SwiperSlide>
                  <button className="slick-next slick-arrow" type="button" aria-label="Next" />
                </Swiper>
              </div>
            </div>
          </section>
          {showdetails ? (<Showdetailspopup data={details} Closebtn={Closepopup} />) : null}
        </>
      </section>
    </>
  );
}

export default Layout17;
